<template>
  <FormModel v-bind="$attrs" v-on="$listeners">
    <slot />
  </FormModel>
</template>

<script>
import { FormModel } from "ant-design-vue";
export default {
  components: {
    FormModel
  }
};
</script>

<style lang="scss">
.has-error {
  .ant-form-explain {
    font-weight: 400;
    position: absolute;
  }
}
</style>
